import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss';

import logo from '../../theme/assets/other/ftf_cabinet_logo.png';
import googleIcon from '../../theme/assets/svg/ftf_google_icon.svg';
import {useNavigate, useParams} from "react-router-dom";
import {
    classicRegistration,
    classicRegistrationFailure,
    googleWidgetAuthorization
} from "../../store/main/action";
import {useDispatch, useSelector} from "react-redux";
import {useGoogleLogin} from "@react-oauth/google";


const RegPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {refCode} = useParams();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const formErr = useSelector(store => store.main.classicRegistrationErr);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');

    const sendFormHandler = useCallback(()=>{
        if (refCode){
            dispatch(classicRegistration({email, password, password_confirmation: password, username, referral_code: refCode}));
        } else {
            dispatch(classicRegistration({email, password, password_confirmation: password, username}));
        }

    }, [refCode, dispatch, email, password, username])

    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'openid email profile',
        onSuccess: async ({ code }) => {
            // отправляем code на бэкенд
            if (refCode){
                dispatch(googleWidgetAuthorization({code, referral_code: refCode}));
            } else {
                dispatch(googleWidgetAuthorization({code}));
            }

            // или:
            // await fetch('/api/google/exchange-code', {
            //   method: 'POST',
            //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            //   body: new URLSearchParams({ code }).toString(),
            // });
        },
        onError: () => console.log('Ошибка входа'),
    });

    useEffect(() => {
        if (authStatus){
            navigate('/matrix');
        }
    }, [authStatus, navigate]);

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    return (
        <section className={`${Styles.container} ${Styles.pagePadding}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={Styles.posWrap}>
                    <div className={Styles.logoWrap}>
                        <div className={Styles.logoWrapIconWrap}>
                            <img src={logo} alt="F#ck the Fomo"/>
                        </div>
                        <div className={Styles.logoWrapText}>F#ck the Fomo</div>
                    </div>
                    <div className={Styles.formWrap}>
                        <div className={Styles.formTitle}>Create your account</div>
                        <div className={Styles.formBox}>
                            <div className={`${Styles.inputWrap} ${formErr?.email ? Styles.inputWrapWithErr : null}`}>
                                <div className={Styles.inputTitle}>Your email</div>
                                <input
                                    type="text"
                                    className={Styles.ftfBorderInput}
                                    placeholder="example@gmail.com"
                                    value={email}
                                    onChange={(e)=>{setEmail(e.target.value)}}
                                    onKeyDown={(event)=>{
                                        if (formErr.email){
                                            delete formErr.email;
                                            dispatch(classicRegistrationFailure(formErr));
                                        }
                                    }}
                                />
                                <div className={`${Styles.inputErr}`}>{formErr?.email ? formErr.email : ''}</div>
                            </div>
                            <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                                <div className={Styles.inputTitle}>Create a password</div>
                                <input
                                    type="password"
                                    className={Styles.ftfBorderInput}
                                    placeholder="********"
                                    value={password}
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                    onKeyDown={(event)=>{
                                        if (formErr.password){
                                            delete formErr.password;
                                            dispatch(classicRegistrationFailure(formErr));
                                        }
                                    }}
                                />
                                <div className={`${Styles.inputErr}`}>{formErr?.password?.[0] ? formErr.password[0] : ''}</div>
                            </div>
                            <div className={`${Styles.inputWrap} ${formErr?.username ? Styles.inputWrapWithErr : null}`}>
                                <div className={Styles.inputTitle}>Create a nickname</div>
                                <input
                                    type="text"
                                    className={Styles.ftfBorderInput}
                                    placeholder="@expert"
                                    value={username}
                                    onChange={(e)=>{setUsername(e.target.value)}}
                                    onKeyDown={(event)=>{
                                        if (formErr.username){
                                            delete formErr.username;
                                            dispatch(classicRegistrationFailure(formErr));
                                        }
                                    }}
                                />
                                <div className={`${Styles.inputErr}`}>{formErr?.username ? formErr.username : ''}</div>
                            </div>
                        </div>
                        <div className={Styles.ftfBorderBtn} onClick={()=>{sendFormHandler()}}>Sign up</div>
                    </div>
                    <div className={Styles.link}>Don't have an account yet? <span onClick={()=>{navigate('/sign-in')}}>Sign in</span></div>
                    <div className={Styles.btnsWrap}>
                        <div className={`${Styles.btnsWrapItem} ${Styles.ftfBorderBtn}`}>
                            <div className={`${Styles.btnsWrapItemIconWrap}`}>
                                <img src={googleIcon} alt="Sign up with Google"/>
                            </div>
                            <div className={`${Styles.btnsWrapItemText}`}>Sign up with Google</div>
                            <div className={`${Styles.googleWrap}`}>
                                <button onClick={() => login()}>Войти через Google</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RegPage;
